import { categories } from '@/mocks/categories';
import type { Article } from '@/mocks/articles';

export const getCategoryName = (key: string): string =>
  categories.find((item) => item.key === key)?.name ?? '案例';

export const getCategoryIcon = (key: string): string =>
  categories.find((item) => item.key === key)?.icon ?? 'ri-file-list-3-line';

export const statusMeta: Record<
  Article['status'],
  { label: string; className: string; dot: string }
> = {
  reversed: {
    label: '已反转',
    className: 'bg-primary-100 text-primary-800 border-primary-200',
    dot: 'bg-primary-500',
  },
  confirmed: {
    label: '已澄清',
    className: 'bg-secondary-100 text-secondary-800 border-secondary-200',
    dot: 'bg-secondary-500',
  },
  clarifying: {
    label: '澄清中',
    className: 'bg-accent-100 text-accent-900 border-accent-200',
    dot: 'bg-accent-500',
  },
};

export const getStatus = (status: Article['status']) =>
  statusMeta[status] ?? statusMeta.clarifying;